interface ArrayUtils {
  remove<T>(arr: T[], ...items: T[]): T[];
}

const utils = {} as ArrayUtils;

export default utils;

utils.remove = function <T>(arr: T[], ...items: T[]): T[] {
  let what,
    L = items.length,
    ax;
  while (L > 0 && arr.length) {
    what = items[--L];
    while ((ax = arr.indexOf(what)) !== -1) {
      arr.splice(ax, 1);
    }
  }
  return arr;
};
